{
  "Description": "PL : 99-999",
  "RedundantCharacters": " ",
  "ValidationRegex": "^[0-9]{2}-[0-9]{3}$",
  "TestData": {
    "Valid": [
      "44-100 ",
      "44-100"
    ],
    "Invalid": [
      "44100",
      "44f00",
      "e4410",
      "44-100d",
      "c44-100",
      "b44100",
      "44100a"
    ]
  }
}
